<dx-popup #dxPopup
          (onShowing)="popupShowing(dxPopup)"
          (onHiding)="popupHiding()"
          [showTitle]="showTitle"
          [(visible)]="visible"
          [width]="width"
          [height]="height"
          [wrapperAttr]="{
            'class': componentClass
          }"
          [showCloseButton]="true"
          [position]="position"
          title="{{title}}">

   <div class="flex h-full" style="min-width: 300px">

      <div *ngIf="subtitle"
           [style.background]="schedaColor"
           class="flex-none app-dialog-scheda h-full p-1" >
         <div style="writing-mode: vertical-lr; transform: rotate(180deg);"
              class="font-bold mt-5" [style.color]="textColor">{{subtitle}}</div>
      </div>

      <div class="grow app-dialog-wrapper h-full">
         <div [ngClass]="buttons[0] != null ? 'app-dialog-content' : 'app-dialog-content-full'">

            <div class="app-dialog-title container px-2 py-4 sm:px-4" *ngIf="!showTitle">
               <h2 class="ml-5 font-bold">{{title}}</h2>

               <div class="justify-items-end">
                  <button class="flex-auto" (click)="visible = false">
                     <mat-icon>close</mat-icon>
                  </button>
               </div>
            </div>

            <dx-scroll-view *ngIf="dxPopupVisible"
                            [useNative]="true"
                            [ngStyle]="{'padding-bottom':  mode == 'normal' ? '90px' : '10px'}">
               <ng-container *ngTemplateOutlet="content"></ng-container>
            </dx-scroll-view>
         </div>

         <div class="app-dialog-footer bg-white"
              [hidden]="!dxPopupVisible"
              *ngIf="buttons[0] != null || buttons.length > 1"
              [style.left.px]="subtitle ? 26 : 0">
            <div *ngFor="let item of buttons">
               <div *ngIf="!item"></div>
               <button *ngIf="item" class="ds-btn h-full w-full"
                       [ngClass]="item.cssClass ? item.cssClass : 'ds-btn-info'"
                       (click)="clickButton(item)">
                  {{item.text}}
               </button>
            </div>

         </div>
      </div>

   </div>

</dx-popup>
